// Internal Imports
import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";
import { truncate } from "../../util/format-text";
import { format } from "date-fns";
import { MdImageSearch, MdWarning } from "react-icons/md";
import VehicleFlags from "../vehicles-page/VehicleFlags";
import CustomerFlags from "../customers-page/CustomerFlags";

/** ========================================================================
 * * Booking Card
 * Renders a card to summarize booking details.
 * ========================================================================== */

export default function BookingCard({ booking }) {
  const { navigate } = useContext(UtilityContext);

  const classNames = () => {
    let classes =
      "grid items-center gap-2 text-center lg:text-start lg:text-sm lg:grid-cols-7 pill";
    if (booking.customer?.unpaidInvoices) classes += " border-red-600";
    else if (booking.status === "cancelled") classes += " border-blue-600";
    else if (booking.status === "completed") classes += " border-stone-600";
    else if (new Date(booking.endDate) <= new Date())
      classes += " border-orange-500";
    else classes += " border-green-600";
    return classes;
  };

  return (
    <div
      onClick={(e) => navigate(`/bookings/info?id=${booking.id}`, e)}
      className={classNames()}
    >
      <div className="flex space-x-4 lg:col-span-2">
        <img
          alt="Vehicle"
          src={booking.vehicle.cornerImage}
          className="w-32 lg:w-28"
        />
        <div className="grid content-center">
          <p className="font-semibold text-stone-200">
            {booking.customer.firstName} {booking.customer.lastName}
          </p>
          <p className="text-stone-400">
            {truncate(
              `${booking.vehicle.model} ${booking.vehicle.vin.slice(13, 17)}`
            )}
          </p>
        </div>
      </div>
      <div className="hidden lg:grid text-stone-200">
        <p>{format(new Date(booking.startDate), "do MMM hh:mm a")}</p>
        <p>{format(new Date(booking.endDate), "do MMM hh:mm a")}</p>
      </div>
      <div className="hidden lg:grid text-stone-400 lg:col-span-2">
        <p>{truncate(booking.pickUpLocation)}</p>
        <p>{truncate(booking.dropOffLocation)}</p>
      </div>
      <div className="hidden space-x-4 lg:flex lg:col-span-2">
        <VehicleFlags vehicle={booking.vehicle} />
        <CustomerFlags customer={booking.customer} />
        <MdImageSearch
          className={
            booking.checkInImages?.length > 0
              ? "w-5 h-5 text-green-600"
              : "w-5 h-5 text-stone-400"
          }
          title="Booking Images"
        />
      </div>
    </div>
  );
}
